(function() { window.GUID_a699e5fd_43cb_4176_8b99_ac6b57a6e479 = { getGuid: function() { return "a699e5fd-43cb-4176-8b99-ac6b57a6e479"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let StatType;
        (function (StatType) {
            StatType[StatType["Team"] = 0] = "Team";
            StatType[StatType["Single"] = 1] = "Single";
        })(StatType = Enumeration.StatType || (Enumeration.StatType = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StatType.pre.js.map
